/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The PNG has a transparent background, so you can place it over a document, contract or form without a white box behind it.`)
};

const es_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El PNG tiene un fondo transparente, por lo que puedes colocarlo sobre un documento, contrato o formulario sin una caja blanca detrás.`)
};

const de_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Die PNG hat einen transparenten Hintergrund, sodass Sie sie über ein Dokument, einen Vertrag oder ein Formular platzieren können, ohne dass eine weiße Box dahinter liegt.`)
};

const nl_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De PNG heeft een transparante achtergrond, zodat u deze over een document, contract of formulier kunt plaatsen zonder een wit vak erachter.`)
};

const fr_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le PNG a un arrière-plan transparent, vous pouvez donc le placer sur un document, un contrat ou un formulaire sans une boîte blanche derrière.`)
};

const it_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il PNG ha uno sfondo trasparente, quindi puoi posizionarlo su un documento, contratto o modulo senza una scatola bianca dietro.`)
};

const pt_br2_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O PNG tem um fundo transparente, então você pode colocá-lo sobre um documento, contrato ou formulário sem uma caixa branca atrás.`)
};

const pt_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O PNG tem fundo transparente, portanto pode colocá-lo sobre um documento, contrato ou formulário sem uma caixa branca atrás.`)
};

const ja_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。PNGは透明な背景を持つため、文書、契約書、フォームの上に配置できます。背後に白いボックスがありません。`)
};

const zh_sig_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。PNG 有透明背景，因此您可以将其放在文档、合同或表单上，背后没有白色方框。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_faq2_a", locale)
	if (locale === "en") return en_sig_hub_faq2_a(inputs)
	if (locale === "es") return es_sig_hub_faq2_a(inputs)
	if (locale === "de") return de_sig_hub_faq2_a(inputs)
	if (locale === "nl") return nl_sig_hub_faq2_a(inputs)
	if (locale === "fr") return fr_sig_hub_faq2_a(inputs)
	if (locale === "it") return it_sig_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_faq2_a(inputs)
	if (locale === "pt") return pt_sig_hub_faq2_a(inputs)
	if (locale === "ja") return ja_sig_hub_faq2_a(inputs)
	return zh_sig_hub_faq2_a(inputs)
};